module.exports = __webpack_public_path__ + "img/photo_2023-04-27 22.15.20.ae1769c4.jpeg";